import React from 'react'

function GroupedOffers({ offre, setSelectedOffre }) {
  return (
    <div className="card ">
      <div className="card-content">
        <span className="card-title">{offre.title}</span>
        <p>{offre.description}</p>

      </div>
      <div className="card-action">
          <a href="javascript:void(0)" onClick={() => setSelectedOffre(offre)}>Voir les clients concernés</a>
      </div>
    </div>
  )
}

export default GroupedOffers